var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDivert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.227 6.89699C18.966 9.18554 18.7395 11.555 17.7724 13.5643L19.4056 14.3964C20.097 14.7487 20.0173 15.7611 19.2794 16.0008L14.6524 17.5042C14.1949 17.6529 13.7036 17.4025 13.5549 16.945L12.0516 12.3181C11.8118 11.5801 12.5839 10.9206 13.2753 11.2729L15.1845 12.2457C15.8358 10.8563 15.9404 9.29843 15.4772 7.82992C14.4686 4.63194 11.0144 2.78236 7.72846 3.88051C4.61132 4.92225 2.81192 8.30846 3.864 11.5464C4.32521 12.9659 5.26771 14.1429 6.5389 14.8987C6.7357 15.0157 6.80729 15.2658 6.70337 15.4698L5.77925 17.2835C5.66573 17.5063 5.38888 17.587 5.17216 17.4624C3.30807 16.39 1.81976 14.6499 1.10287 12.4436C-0.433112 7.71632 2.15394 2.63896 6.88115 1.10296C11.603 -0.431299 16.7012 2.1724 18.227 6.89699Z",
    fill: "#BEBEBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivert);
export default __webpack_public_path__ + "static/media/Divert.2218b69f.svg";
export { ForwardRef as ReactComponent };